import "./pageAdress.css"
import { FaHouse } from "react-icons/fa6"


function PageAdress(props) {
    return (
        <div className="page-address">
            <div className="info-page">
                <div style={{ display: "flex" }}>
                    <h2 className="page-URL actived-page">{props.data}</h2>
                    {props.data2 &&
                        <>
                            <h2 className="page-URL">/</h2>
                            <h2 className="page-URL ">{props.data2}</h2>
                        </>
                    }
                    {props.data3 &&
                        <>
                            <h2 className="page-URL">/</h2>
                            <h2 className="page-URL ">{props.data3}</h2>
                        </>
                    }

                </div>
                <div style={{ zIndex: "995" }}>
                    <FaHouse /> <span> / </span> {props.data}
                </div>
            </div>
            <div className="bubble bubble1"></div>
            <div className="bubble bubble2"></div>
            <div className="bubble bubble3"></div>
            <div className="bubble bubble4"></div>
        </div>
    )
}

export default PageAdress;